<template>
    <v-container fluid>
        <!-- inicio de cambiar de rancho -->
        <v-row class="pa-0 ma-0 align-center"
               justify="center"
               no-gutters>
            <v-col cols="8" justify="justify-center" class="ma-0 pa-0">
                <ChangeRanch
                    :paddock="paddockSelected"
                    :paddocks="currentPaddocks">
                </ChangeRanch>
            </v-col>
        </v-row>
        <!-- fin de cambiar de rancho -->

        <!-- inicio de texto principal -->
        <v-row class="my-3 px-2 smart-title-2 home-title-container-mobile"
               no-gutters>
            <v-col cols="12" class="d-flex align-center justify-center">
                <div class="unselectable" style="text-align:center">Continua agregando potreros a tu rancho</div>
            </v-col>
        </v-row>
        <!-- fin de texto principal -->

        <!-- inicio de tarjeta de vacas en sistema -->
        <v-col cols="12" class="pa-0">
            <SystemCardCount height="40px"
                             width="100%"
                             number="100"
                             title-background="#57A7F5"
                             number-background="#1460AA"
                             title="Vacas en Sistema">
             </SystemCardCount>
          </v-col>
        <!-- fin de tarjeta de vacas en sistema -->

        <!-- inicio de tarjetas de grupos -->
        <v-col cols="12" class="card-cointainer-max-height std-cards-container std-border-radius cards-container-border pa-0 mt-2 mb-4">
            <v-row class="full-height px-0 pt-0 d-flex justify-center align-center"
                   no-gutters>
              <div class="inline-flex std-card-container std-container-shadow">
                <CardItemGroup title="Recién nacidas"></CardItemGroup>
              </div>
              <div class="inline-flex std-card-container std-container-shadow">
                <CardItemGroup title="Recién nacidas"></CardItemGroup>
              </div>
              <div class="inline-flex std-card-container std-container-shadow">
                <CardItemGroup title="Recién nacidas"></CardItemGroup>
              </div>
              <div class="inline-flex std-card-container std-container-shadow">
                <CardItemGroup title="Recién nacidas"></CardItemGroup>
              </div>
            </v-row>
          </v-col>
        <!-- fin de tarjetas de grupos -->

        <!-- inicio de controles inferiores -->
        <v-row cols="12" class="d-flex align-center justify-center" no-gutters>
            <v-col cols="4" class="d-flex align-center justify-start icon-container-arrows">
                <img src="../assets/Arrow_Left.svg" alt="#"/>
            </v-col>

            <v-col cols="4" class="d-flex align-center justify-center">
                <v-btn text class="my-2 d-flex std-text-grey">
                    Omitir paso
                </v-btn>
            </v-col>

            <v-col cols="4" class="d-flex align-center justify-end icon-container-arrows full-height">
                <img src="../assets/Arrow_Right.svg" alt="#"/>
            </v-col>
        </v-row>
        <!-- fin de controles inferiores -->
    </v-container>
</template>

<script>
    import ChangeRanch from '@/components/ChangeRanch.vue';
    import SystemCardCount from "../components/SystemCardCount";
    import CardItemGroup from "../components/CardItemGroup";
    export default {
      name: 'MobileComponents',
        data () {
          return {
          }
      },
      components: {
        ChangeRanch,
        SystemCardCount,
        CardItemGroup
      },
      computed: {
      },
      methods: {
      },
      mounted () {
      }
    };
</script>
    
<style lang="css">
    @import '../style/MobileCowStall.css';
    @import '../style/BaseStyle.css';
</style>